The subscription stream to retrieve events from.

This can be used in combination with `deliveredIndicator` to identify events that were not successfully delivered through a particular webhook subscription.

Omit this field to consume events solely through GraphQL polling.
This will retrieve events from a persistent stream that is not associated with a webhook subscription.
